import { useEffect, useState } from 'react'

import { useDebounce } from '@img-arena/consoles-utils'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, InputAdornment } from '@mui/material'
import { ConsoleTextField } from '@/components/inputs/StyledInputComponents'

import type { FilterType } from '../../base/FilterableTable/FilterableTable.types'

type Props = {
  onFilterSelect: (value: FilterType | null) => void
  width?: string | number
  debounceDelay?: number
  placeholder?: string
  defaultValue?: string
}

export const FreeTextFilter = ({
  onFilterSelect,
  width,
  debounceDelay = 500,
  placeholder = 'Search',
  defaultValue
}: Props) => {
  const [search, setSearch] = useState(defaultValue ?? '')
  const debouncedSearch = useDebounce(search, debounceDelay)

  useEffect(() => {
    onFilterSelect(debouncedSearch ? { value: debouncedSearch, label: debouncedSearch } : null)
  }, [debouncedSearch])

  const handleClear = () => {
    setSearch('')
    onFilterSelect(null)
  }

  return (
    <ConsoleTextField
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder={placeholder}
      sx={{
        width: width ?? 300
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {!!search && (
              <IconButton onClick={handleClear}>
                <CloseIcon />
              </IconButton>
            )}

            <SearchIcon color="action" sx={{ mr: -0.5, mb: -0.05 }} />
          </InputAdornment>
        )
      }}
    />
  )
}
